import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Navbar as BSNavbar, Nav, Container, Image } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHome, faSignInAlt, faUserPlus } from '@fortawesome/free-solid-svg-icons';
import AuthService from '../../services/AuthService';
import logo from '../../logo-bachiller-digital.png';
import './Navbar.css';
import logo_bachiller from '../../logo-bachiller-digital.png';

const Navbar = ({ currentUser, isAdmin, logOut }) => {
  const location = useLocation();
  const [expanded, setExpanded] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const [isNavCollapsed, setIsNavCollapsed] = useState(true);

  // Hide navbar on specific routes when logged in
  const hideNavbar = (
    location.pathname !== '/' &&
    location.pathname !== '/home' &&
    location.pathname !== '/login' && 
    location.pathname !== '/register' &&
    !location.pathname.startsWith('/rendicion-de-cuentas')
  );


  // Hide navbar if user is logged in and not on login/register pages
  if (hideNavbar) {
    return null;
  }

  const handleNavCollapse = () => {
    setIsNavCollapsed(!isNavCollapsed);
  }

  const closeNav = () => {
    setExpanded(false);
    setIsNavCollapsed(true);
  };
  
  // Cerrar el menú al hacer clic en un enlace
  const handleNavLinkClick = () => {
    if (window.innerWidth <= 990) { // Ancho típico para menú móvil
      setExpanded(false);
      setIsNavCollapsed(true);
    }
  };

  return (
    <BSNavbar 
      bg="white"
      expand="lg" 
      fixed="top" 
      expanded={expanded}
      className="navbar-custom"
    >
      <Container fluid>
        <BSNavbar.Brand as={Link} to="/" className="d-flex align-items-center">
          <img 
            src={logo_bachiller} 
            alt="Bachiller Digital Daule" 
            height="80"
            className="d-inline-block align-top"
          />
        </BSNavbar.Brand>
        
        <BSNavbar.Toggle 
          aria-controls="basic-navbar-nav" 
          onClick={() => setExpanded(!expanded)}
          className="border-0"
        >
          <span className="navbar-toggler-icon"></span>
        </BSNavbar.Toggle>
        
        <BSNavbar.Collapse id="basic-navbar-nav">
          <Nav className="me-auto">
            <Nav.Link as={Link} to="/home" className="nav-link text-white" onClick={handleNavLinkClick}>
              <FontAwesomeIcon icon="home" className="me-1"/> Inicio
            </Nav.Link>
          </Nav>
          
          <Nav className="ms-auto">
            <Nav.Link as={Link} to="/login" className="nav-link me-3 text-white" onClick={handleNavLinkClick}>
              <FontAwesomeIcon icon={faSignInAlt} className="me-1" /> Iniciar sesión
            </Nav.Link>
            <Nav.Link as={Link} to="/register" className="nav-link me-3 text-white" onClick={handleNavLinkClick}>
              <FontAwesomeIcon icon={faUserPlus} className="me-1" /> Registrarse
            </Nav.Link>
          </Nav>
        </BSNavbar.Collapse>
      </Container>
    </BSNavbar>
  );
};

export default Navbar;
